import { render } from "./App.vue?vue&type=template&id=7d65bc72"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7d65bc72&lang=css"

import exportComponent from "/Users/xiejigang/vue/duostec-pc-m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__